export default __webpack_public_path__ + "static/media/6.e32761c9.jpeg";